import React, { useCallback, useEffect, useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  TextField,
  Paper,
  TablePagination,
  Typography,
  CircularProgress,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  DialogTitle,
  DialogContent,
  DialogActions,
  Dialog,
  DialogContentText,

} from '@material-ui/core';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import Layout from './Layout';


export const ListAllEnvs = () => {


  const [responseData, setResponseData] = useState(null);
  const [editId, setEditId] = useState(null);
  const [newFarmId, setNewFarmId] = useState(null);
  const [newOrgId, setNewOrgId] = useState(null);
  const [newActive, setNewActive] = useState(null);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [loading, setLoading] = useState(false);

  const [totalCount, setTotalCount] = useState(0);

  const [searchEnv, setSearchEnv] = useState('');
  const [searchOrg, setSearchOrg] = useState('');
  const [searchFarm, setSearchFarm] = useState('');


  const [activeApi, setActiveApi] = useState("All");
  const [deleteEnvId, setDeleteEnvId] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [selectedENVSToDelete, setSelectedENVSToDelete] = useState(null);


  const baseUrl = localStorage.getItem('environment') === "dev" || !localStorage.getItem('environment') ? "https://dev.phyfarm.com/" : "https://v3.api.phyfarm.com/";
  console.log(baseUrl, window.environment);

  const onUpdateRow = useCallback((env_id, farm_id, org_id, active) => {
    setEditId(env_id);
    setNewFarmId(farm_id);
    setNewOrgId(org_id);
    setNewActive(active);
  }, []);

  const getAllEnvs = useCallback(() => {

    const filters = {};

    if (searchEnv) {
      filters.env_id = searchEnv;
    }

    if (searchOrg) {
      filters.org_id = searchOrg;
    }

    if (searchFarm) {
      filters.farm_id = searchFarm;
    }


    const requestData = {
      pagination: {
        current_page: page + 1,
      },
      filters,
      status: activeApi == "All" ? null : activeApi,
    };


    setLoading(true);

    fetch(baseUrl + 'api/mgmt/env/listAllEnvsCms', {
      method: 'POST',
      headers: {
        'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(requestData)
    })
      .then(response => response.json())
      .then(data => {
        setResponseData(data.data.envs.envs);
        setTotalCount(data.data.envs.totalCount);
        onUpdateRow(null, null, null, null);
        setLoading(false);
        console.log(data);
      })

      .catch(error => {
        console.log(error);
        alert(error, "An error occured while fetching data");

      });

  }, [baseUrl, onUpdateRow, page, activeApi, searchEnv, searchOrg, searchFarm]);


  useEffect(() => {
    getAllEnvs();
  }, [activeApi, page]);


  const handleSearchEnvChange = (e) => {
    setSearchEnv(e.target.value);
  };

  const handleSearchOrgChange = (e) => {
    setSearchOrg(e.target.value);
  };

  const handleSearchFarmChange = (e) => {
    setSearchFarm(e.target.value);
  };

  const handleSearch = () => {
    const filters = {};

    if (searchEnv) {
      filters.env_id = searchEnv;
    }

    if (searchOrg) {
      filters.org_id = searchOrg;
    }

    if (searchFarm) {
      filters.farm_id = searchFarm;
    }

    const requestData = {
      pagination: {
        current_page: page + 1,
      },
      filters,
      status: activeApi,
    };

    getAllEnvs(requestData);
  }

  const onSave = useCallback((env_id, farm_id, org_id, active) => {

    console.log("This is the active val", active)

    const isActive = active === "true" ? true : false;

    console.log("Value after ops", isActive)

    fetch(baseUrl + 'api/mgmt/env/updateOrgAndFarm', {
      method: 'POST',
      headers: {
        'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        env_id,
        farm_id,
        org_id,
        active: isActive
      })
    })
      .then(response => response.json())
      .then(data => {

        if (data.error) {
          alert(data.error.code);
        } else {
          setEditId(null);
          setNewFarmId(null);
          setNewOrgId(null);
          getAllEnvs();
        }
      })
      .catch(error => {
        console.log(error);
        alert(error, "An error occured while fetching data");
      });

  }, [baseUrl, getAllEnvs]);



  const handleChangePage = useCallback((event, newPage) => {

    console.log('New page', newPage)
    setPage(newPage);
    console.log('After set', page)
    // getAllEnvs(); // Call getAllEnvs with the updated page value

  }, []);



  const handleChangeRowsPerPage = useCallback(event => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  }, []);



  const closeDeleteDialog = () => {
    setDeleteEnvId(null);
    setIsDeleteDialogOpen(false);
  };


  const deleteConfirmation = (payment) => {

    setIsDeleteDialogOpen(true);
    setSelectedENVSToDelete(payment);
  };

  const handleDelete = () => {

    const envs = selectedENVSToDelete;
    console.log('envs', envs);

    setIsDeleteDialogOpen(false);
    setDeleteLoading(true);

    const apiUrl = baseUrl + 'api/mgmt/env/archiveEnv';
    // const authToken = 'Access eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c';
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c',
    };
    const requestBody = JSON.stringify({
      org_id: envs.org_id,
      farm_id: envs.farm_id,
      env_id: envs.env_id,
    });

    fetch(apiUrl, {
      method: 'POST',
      headers: headers,
      body: requestBody,
    })
      .then(response => response.json())
      .then(data => {
        console.log('Delete payment response:', data);

        console.log('Payment entry deleted successfully')
        // Payment entry was deleted successfully, update the table data
        // const updatedEnvsList = responseData.filter(item => item.id !== .id);
        const updatedEnvsList = responseData.filter(item => item.env_id !== envs.env_id);
        setResponseData(updatedEnvsList);

        getAllEnvs();;

        console.log('Delete payment response:', data);
        setDeleteLoading(false);

      })
      .catch(error => {
        console.error('Error deleting payment:', error);
        // Handle error if necessary
        setDeleteLoading(false);
      });
  };


  console.log('response Data', responseData)
  console.log('Page', page)

  return (

    <Layout>
      <div className="App" style={{ marginTop: 100 }}>
        <Typography variant="h5" style={{ marginBottom: 20 }}>Update FarmId and OrgId</Typography>


        <div style={{ display: 'flex', alignItems: 'center', marginTop: 50, marginBottom: 50 }}>
          <div style={{ marginLeft: 20 }}>
            <TextField
              label="Search by Env"
              value={searchEnv}
              variant="outlined" x
              disabled={searchOrg || searchFarm}
              onChange={handleSearchEnvChange}
              onKeyPress={e => e.key === 'Enter' && getAllEnvs()}
            />
          </div>
          <div style={{ marginLeft: 20 }}>
            <TextField
              label="Search by Org Id"
              value={searchOrg}
              variant="outlined"
              disabled={searchEnv || searchFarm}
              onChange={handleSearchOrgChange}
              onKeyPress={e => e.key === 'Enter' && getAllEnvs()}
            />
          </div>
          <div style={{ marginLeft: 20 }}>
            <TextField
              label="Search by Farm Id"
              value={searchFarm}
              variant="outlined"
              disabled={searchEnv || searchOrg}
              onChange={handleSearchFarmChange}
              onKeyPress={e => e.key === 'Enter' && getAllEnvs()}
            />
          </div>
          <div style={{ marginRight: '20px', marginLeft: 2 }}>
            <Button variant="primary" onClick={handleSearch}>
              <IconButton color="primary">
                <SearchIcon />
              </IconButton>
            </Button>
          </div>
          <div style={{ flexGrow: 1 }}></div>
          <div>

            <FormControl style={{ width: '200px' }}>
              <InputLabel id="demo-simple-select-helper-label">Filter By Status</InputLabel>
              <Select
                labelId="demo-simple-select-helper-label"
                id="demo-simple-select-helper"
                value={activeApi}
                label="Filter By Status"
                onChange={e => setActiveApi(e.target.value)}
              >
                <MenuItem value="All">All</MenuItem>
                <MenuItem value="true">Active</MenuItem>
                <MenuItem value="false">Inactive</MenuItem>
              </Select>
            </FormControl>

          </div>

          <div>
            <TablePagination
              rowsPerPageOptions={[]}
              component="div"
              count={totalCount}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              labelRowsPerPage=""
              labelDisplayedRows={({ from, to, count }) => `Navigate to Next Page: ${from}-${to} of ${count}`}
            />
          </div>
        </div>




        {
          loading ? (
            <div style={{ textAlign: 'center', marginBottom: 20 }}>
              <CircularProgress />
            </div>
          ) : (
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell align='center' style={{ fontWeight: 'bold' }}>Env ID</TableCell>
                    <TableCell align='center' style={{ fontWeight: 'bold' }}>Serial ID</TableCell>
                    <TableCell align='center' style={{ fontWeight: 'bold' }}>Env Name</TableCell>
                    <TableCell align="center" style={{ fontWeight: 'bold' }}>Org Id</TableCell>
                    <TableCell align="center" style={{ fontWeight: 'bold' }}>Farm Id</TableCell>
                    <TableCell align="center" style={{ fontWeight: 'bold' }}>Created At</TableCell>
                    <TableCell align="center" style={{ fontWeight: 'bold' }}>Mac Address</TableCell>
                    <TableCell align="center" style={{ fontWeight: 'bold' }}>Status</TableCell>
                    <TableCell align="center" style={{ fontWeight: 'bold' }}>Edit</TableCell>
                  </TableRow>
                </TableHead>


                <TableBody>

                  {
                    Array.isArray(responseData)
                      ? responseData.map((item, index) => (

                        <TableRow
                          key={index}
                          sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                          style={{ height: 90 }}
                        >
                          <TableCell align="center" component="td" scope="row">
                            {item.env_id}
                          </TableCell>
                          <TableCell align="center" component="td" scope="row">
                            {item.serial_id}
                          </TableCell>
                          <TableCell align="center" component="td" scope="row">
                            {item.env_name}
                          </TableCell>
                          <TableCell align="center" component="td" scope="row" style={{ width: 200 }}>
                            {
                              item.env_id !== editId
                                ? <span>{item.org_id}</span>
                                : <TextField
                                  label="New Org Id"
                                  value={newOrgId}
                                  type='number'
                                  variant="outlined"
                                  onChange={e => setNewOrgId(parseInt(e.target.value, 10))}
                                  style={{ width: 150 }}
                                />
                            }
                          </TableCell>
                          <TableCell align="center" component="td" scope="row" style={{ width: 200 }}>
                            {
                              item.env_id !== editId
                                ? <span>{item.farm_id}</span>
                                : <TextField
                                  label="New Farm Id"
                                  value={newFarmId}
                                  type='number'
                                  variant="outlined"
                                  onChange={e => setNewFarmId(parseInt(e.target.value, 10))}
                                  style={{ width: 150 }}
                                />
                            }
                          </TableCell>
                          <TableCell align="center">{item.updated_at}</TableCell>
                          <TableCell align="center">{item.mac_address}</TableCell>
                          {/* <TableCell align="center">{item.active ? <span style={{ color: "green" }}>TRUE</span> : <span style={{ color: "red" }}>FALSE</span>}</TableCell> */}

                          <TableCell align="center">
                            {
                              item.env_id !== editId
                                ? (

                                  item.active ? <span style={{ color: "green" }}>ACTIVE</span> : <span style={{ color: "red" }}>IN-ACTIVE</span>
                                )
                                : <Select
                                  labelId="demo-simple-select-label"
                                  id="demo-simple-select"
                                  value={newActive || item.active}
                                  onChange={e => setNewActive(e.target.value)}
                                  style={{ width: 150 }}
                                >
                                  <MenuItem value="true">Active</MenuItem>
                                  <MenuItem value="false">Inactive</MenuItem>
                                </Select>
                            }
                          </TableCell>
                          <TableCell align="center" style={{ width: 250 }}>
                            {item.env_id !== editId
                              ? (<>
                                <Button variant="outlined" color="primary" style={{ marginRight: 5 }} onClick={() => onUpdateRow(item.env_id, item.farm_id, item.org_id, item.active.toString())}>
                                  Update
                                </Button>
                                <Button
                                  variant="outlined"
                                  color="secondary"
                                  onClick={() => deleteConfirmation(item)}
                                >
                                  Delete
                                </Button>
                              </>)
                              : <>
                                <Button style={{ marginRight: 10, backgroundColor: '#2e7d32', color: 'white' }} onClick={() => onSave(item.env_id, newFarmId, newOrgId, newActive)}>
                                  Save
                                </Button>
                                <Button variant="outlined" color="secondary" onClick={() => onUpdateRow(null, null, null, null)}>
                                  Cancel
                                </Button>
                              </>
                            }
                          </TableCell>
                        </TableRow>
                      ))
                      : (
                        <TableRow>
                          <TableCell align="center" colSpan={9}>
                            {
                              responseData == null ? (
                                <Typography variant="subtitle1">
                                  No data available
                                </Typography>
                              ) : null
                            }
                          </TableCell>
                        </TableRow>
                      )
                  }
                </TableBody>
              </Table>

            </TableContainer>
          )
        }
      </div>
      <Dialog
        open={isDeleteDialogOpen}
        onClose={closeDeleteDialog}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
        disableEnforceFocus
      >
        <DialogTitle id="delete-dialog-title">Delete Confirmation</DialogTitle>
        <DialogContent>
          <DialogContentText id="delete-dialog-description">
            Do you want to archive the Env?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" color="secondary" onClick={closeDeleteDialog} >
            Cancel
          </Button>
          <Button variant="outlined" onClick={handleDelete} color="primary">
            Archive
          </Button>
        </DialogActions>
      </Dialog>

    </Layout >
  );
};

export default ListAllEnvs;